import { render } from "./S342751.vue?vue&type=template&id=24c6322e"
const script = {}
script.render = render

export default script